import { useEffect } from 'react';

import { useSearchParams } from '@remix-run/react';

const useRemoveParams = (params: string[]) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let updated = false;

    params.forEach((param) => {
      if (searchParams.has(param)) {
        searchParams.delete(param);
        updated = true;
      }
    });

    if (updated) {
      setSearchParams(searchParams, { replace: true, preventScrollReset: true });
    }
  }, [params, searchParams, setSearchParams]);
};

export default useRemoveParams;
